import { Job, JobStatus } from '../../job-summary/Interfaces';

export interface Customer {
  id: string;
  name: string;
  lastContacted: any;
  email: string;
}

export interface CustomerWithJobs extends Customer {
  activeJobs: Job[];
}

/** One job plus its customer — used for job-centric list view */
export interface JobWithCustomer {
  job: Job;
  customer: CustomerWithJobs;
}

export interface PopoverState {
  anchorEl: HTMLElement | null;
  jobId: string | null;
  currentDate: Date | null;
  tempDate: Date | null;
}

export type SortField = 'name' | 'lastContacted' | 'dueDate' | 'status';
export type SortOrder = 'asc' | 'desc';
export type ViewMode = 'grid' | 'list';
export type StatusFilter = JobStatus[];

// Job cards should stay compact, but users need to browse more than 3 emails.
// Keep a reasonable cap for perf (especially after customer hydration loads lots of emails).
export const MAX_EMAILS_PER_JOB_IN_CARD = 25;
